<template>
  <div class="program-filter-sort-menus">
    <v-menu v-if="filterOptions.length" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <Button text color="brandPrimary" v-bind="attrs" v-on="on">Filter</Button>
      </template>
      <v-list>
        <v-list-item
          v-for="option in filterOptions"
          :key="option.value"
          @click="$emit('toggle-filter', option.value)"
        >
          <v-list-item-action>
            <span @click.stop="$emit('toggle-filter', option.value)">
              <v-checkbox
                :input-value="selectedFilters.includes(option.value)"
                :ripple="false"
                readonly
              />
            </span>
          </v-list-item-action>
          <v-list-item-icon v-if="option.icon">
            <Icon :icon="option.icon" />
          </v-list-item-icon>
          <v-list-item-content class="align-text-left">
            <v-list-item-title>{{ option.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu v-if="sortOptions.length" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <Button text color="brandPrimary" v-bind="attrs" v-on="on">Sort</Button>
      </template>
      <v-list>
        <v-list-item
          v-for="option in sortOptions"
          :key="option.value"
          :class="{ 'light-grey-background': option.value === sortBy }"
          @click="onSort(option)"
        >
          <v-list-item-content class="align-text-left">
            <v-list-item-title>{{ option.label }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon v-if="option.value === sortBy">
            <Icon :icon="sortOrder === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'" />
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Icon from "@/components/generic/Icon.vue";

export default {
  name: "ProgramFilterSortMenus",
  components: { Button, Icon },
  emits: ["toggle-filter", "update-sort"],
  props: {
    filterOptions: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: Array,
      default: () => [],
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    sortBy: {
      type: String,
      default: null,
    },
    sortOrder: {
      type: String,
      default: "asc",
    },
  },
  methods: {
    onSort(option) {
      const sortOrder = this.sortBy === option.value && this.sortOrder === "asc" ? "desc" : "asc";
      this.$emit("update-sort", { sortBy: option.value, sortOrder });
    },
  },
};
</script>

<style scoped>
.program-filter-sort-menus {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
